import React from 'react';
import ServerMonitor from './ServerMonitor';

/**
 * Server Monitor Page - ServerMonitor 컴포넌트 래퍼
 * section prop을 통해 특정 섹션을 기본으로 표시
 */
const ServerMonitorPage = ({ section = 'system' }) => {
  return (
    <div className="server-monitor-page">
      <ServerMonitor activeSection={section} />
    </div>
  );
};

export default ServerMonitorPage;
